import * as z from 'zod';
import { currencySchema } from '../utils.mjs';
import { Adjustment } from './adjustment.mjs';

var AdjustableValue;
(function (AdjustableValue) {
    AdjustableValue.schema = z.object({
        value: currencySchema.optional(),
        adjustment: Adjustment.schema.nullish(),
    });
})(AdjustableValue || (AdjustableValue = {}));

export { AdjustableValue };
